import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-warranty-asset-card',
  templateUrl: './warranty-asset-card.component.html',
  standalone: false,
})
export class WarrantyAssetCardComponent {
  @Input() propertySetId!: string;
  @Input() propertyValues!: Record<string, unknown>;
  @Input() dimensionValues: Record<string, unknown> = {};
}
